import DefaultPaletteOptions from '../defaultPallete';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (palette: DefaultPaletteOptions): any => {
  return {
    styleOverrides: {
      root: {
        minHeight: 40,
        boxShadow: 'none',
        borderRadius: '6px',
        fontSize: '14px',
        fontWeight: 600,
        color: '#FFF',
        textTransform: 'initial',
        '& .MuiButton-endIcon': {
          position: 'absolute',
          right: '20px',
        },
      },
      outlined: {
        // borderColor: palette.primary?.dark,
        border: 0,
        color: palette.primary?.main,
      },
      outlinedSecondary: {
        borderColor: palette.primary?.light,
        backgroundColor: '#FFF',
      },
      sizeSmall: {
        minHeight: 38,
        fontSize: 12,
      },
      sizeLarge: {
        minHeight: 46,
        fontSize: 16,
      },
    },
  };
};
